import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle t='event_one' />
}

const skin = era.skin('routes/events/details')

DetailsEventsPage.displayName = 'DetailsEventsPage'
export function DetailsEventsPage(): JSX.Element {
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className='content-details-page'>
        <ui.RenderSkin name='liveEventBanner' />
        <ui.RenderSkin name='liveEventDetails' />
        <ui.RenderSkin name='liveEventRecommended' />
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
